export default __webpack_public_path__ + "static/media/login-card.3178a8d9.png";